import React from 'react';
import {
  DonateButton,
  InviteButton,
  InviteLabel,
  InviteRow,
  ManageBookingsRow,
  ShareIcons,
  ShareLabel,
  ShareRow,
  SocialFooter,
} from './socialMedia.styled';

interface SocialMediaProps {
  onDonate?: () => void;
  onInvite?: () => void;
  onManageBookings?: () => void;
}

const SocialMedia = ({
  onDonate = () => { },
  onInvite = () => { },
  onManageBookings,
}: SocialMediaProps) => {
  return (
    <div>
      <InviteRow>
        <InviteLabel>Invite your friends : </InviteLabel>
        <InviteButton type="button" onClick={onInvite}>
          &nbsp;Invite&nbsp;&nbsp;
        </InviteButton>
      </InviteRow>
      {onManageBookings ? (
        <ManageBookingsRow>
          <InviteLabel>Manage bookings : </InviteLabel>
          <InviteButton type="button" onClick={onManageBookings}>
            Manage
          </InviteButton>
        </ManageBookingsRow>
      ) : null}
      <SocialFooter>
        <ShareRow>
          <ShareLabel>Share:</ShareLabel>
          <ShareIcons>
            <a href="/#" aria-label="Twitter">
              <i className="icon-twitter" />
            </a>
            <a href="/#" aria-label="Instagram">
              <i className="icon-instagram" />
            </a>
            <a href="/#" aria-label="Facebook">
              <i className="icon-facebook" />
            </a>
          </ShareIcons>
        </ShareRow>
        <DonateButton type="button" onClick={onDonate}>
          Donate
        </DonateButton>
      </SocialFooter>
    </div>
  );
};

export default SocialMedia;
